(function () {
  const BOUND_ATTR = 'data-common-questions-bound';

  function bindAccordion(root) {
    const accordion = root.querySelector('[data-common-questions-accordion]');
    if (!accordion || accordion.hasAttribute(BOUND_ATTR)) return;

    accordion.setAttribute(BOUND_ATTR, 'true');

    accordion.querySelectorAll('details.common-questions__item').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;

        accordion.querySelectorAll('details.common-questions__item').forEach((other) => {
          if (other !== details && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('.common-questions-section').forEach((section) => {
      const accordion = section.querySelector('[data-common-questions-accordion]');
      if (accordion) {
        accordion.removeAttribute(BOUND_ATTR);
      }
      bindAccordion(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
